// number -> IShip -> number
import { pipe } from 'rxjs';
import { getShipConfig } from '../../../config/ship/get-ship-config';
import { multiply, prop } from 'ramda';

export const getFuelCost = (fuelAmount: number) =>
  pipe(getShipConfig, prop('costOfFuel'), multiply(fuelAmount));
